import React, { useState, useRef } from 'react';
import { useSocket } from '../Context/SocketContext';
import { ChevronDown, MessageCircle, Search, ShieldCheck, User } from 'lucide-react';
import moment from 'moment';
import { infoUser } from '../utils/auth';

const SideMinTalk = ({ iMessages, userOnline, onSelect, onSearch, label = "Discutions Streaming", type = "", currentPage = 1, totalPage = 1, onLoadMore }) => {
    const { projectJson, socket,socketSport } = useSocket()
    const user = infoUser();
    const [searchResult, setSearchresult] = useState(null)
    const timeoutRef = useRef(null)

    const searchUser = (s) => {
        if (!s || s.length < 2) return
        clearTimeout(timeoutRef.current)
        timeoutRef.current = setTimeout(async () => {
            try {
                const matchSocket = type == "sport" ? socketSport : socket
                const response = await new Promise((resolve) => {
                    matchSocket.emit(
                        'empire_search_user_talk',
                        { token: user.expecttoken, search: s },
                        (e) => resolve(e)
                    )
                })
                onSearch(response)
                console.log(response)
                // setUsers(response)
            } catch (err) {
                console.error(err)
            }
        }, 500)
    }


    return (
        <div className='container-list-user oys'>
            <div>
            </div>
            <p className='fb cw fs2'>{label}</p>
            <div className='search-user df gap1 mt1'>
                <Search color='#fff' size={20} />
                <input onChange={(v) => searchUser(v.currentTarget.value)} placeholder='Rechercher' className='flex1 cw fr'  ></input>
            </div>
            <div className='container-all-list-user py1'>
                {iMessages?.length > 0 && iMessages.map((m, i) => (
                    <button
                        onClick={() => onSelect(m)} key={i + "_side_discution"}
                        className={`df aifs gap1 mb1 w100 item-line-message-user ${(m?.last_message_date?.role == "user" && m?.last_message_date?.status == "Envoyé") ? "n" : ""} `}>
                        <div className='c-avatar'>
                            {m.user?.path ? (<img className='avatar' src={projectJson?.href + "/images/users/" + m.user.path}></img>) : (<User className='avatar' color='#000' size={15} />)}

                            <div className={`bullet ${userOnline?.includes(parseInt(m.user.id)) ? "on" : ""}`}></div>
                        </div>
                        <div className='df fdc w100 aifs'>
                            <p className='fs1 cw fr truncate' style={{ maxWidth: "200px" }}>{m.user.email}</p>
                            {m.paid && (
                                <span className='df aic gap1 bcs cw fr mt1' style={{ fontSize: "0.7em", borderRadius: "5px", padding: "0.2em 0.5em" }}>
                                    <ShieldCheck size={12} color='#fff' /> À valider
                                </span>
                            )}
                            {m.last_message_date?.date && (
                                <p className='fi fs1 cs tal'>{moment(m.last_message_date.date).fromNow()}</p>
                            )}
                            {m.last_message_date?.message && (
                                <div className='df gap1 mt1' style={{ maxWidth: "200px" }}>
                                    <MessageCircle size={15} color={'#fff'} />
                                    <p className='truncate fs05 cw fl'>{m.last_message_date?.message}</p>
                                </div>
                            )}
                        </div>
                    </button>
                ))}

                {currentPage < totalPage && onLoadMore && (
                    <button
                        onClick={onLoadMore}
                        className='df aic jcc gap1 w100 cw mt1'
                        style={{
                            padding: "10px",
                            borderRadius: "10px",
                            background: "rgba(255,255,255,0.08)",
                            border: "1px solid rgba(255,255,255,0.15)",
                            cursor: "pointer"
                        }}>
                        <ChevronDown size={16} color="#fff" />
                        <span className='fs1'>Voir plus ({currentPage}/{totalPage})</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default SideMinTalk;